/**
 * Throttles calls to a function by guaranteeing that a set amount of time passes between repeated function call executions
 *
 * @param interval Interval between allowed function calls
 * @param callback Callback function that is being throttled
 */
export const throttle = (interval, callback) => {
    // First time the function is called we want it to execute
    let shouldFireCallback = true;
    // The function that will actually be called
    return function throttleFn(...args) {
        // If it hasn't been the specified interval, then just return
        if (!shouldFireCallback) {
            return;
        }
        // Execute the callback function
        callback.apply(this, args);
        // Cancel additional executions of the function until the elapsed time has passed
        shouldFireCallback = false;
        setTimeout(() => {
            shouldFireCallback = true;
        }, interval);
    };
};
